import RiskBadge from '@/components/badges/risk-badge/risk-badge';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { UpArrow } from '@/components/icons/up-arrow';
import { DownArrow } from '@/components/icons/down-arrow';
import { RiskFactor } from '@/repositories/risk.repository';
import { formatRelativeRiskDecimal, getCancerRiskSuffix, normalizeCancerTypeName } from '@/utils';
import MarkdownTextTailwind from '@/components/markdown/markdown-text-tailwind';

type QuantifiableRiskFactorProps = {
  shortDescription: string;
  riskFactor: RiskFactor;
  affectedCancerTypes: string[];
  impactsByCancerType: Record<string, number>;
};

export default function QuantifiableRiskFactor(props: QuantifiableRiskFactorProps) {
  return (
    <div className="modal-section">
      <div className="modal-section-header">
        <div className="modal-section-icon-container">
          <IconCatch icon="risk-impact" size="s" transparentBackground />
        </div>
        <MarkdownTextTailwind className="modal-section-title">
          {'Risk impact relative to population average'}
        </MarkdownTextTailwind>
      </div>
      <div className="modal-section-content modal-risk-impact-content">
        <MarkdownTextTailwind className="modal-section-text">{`${props.shortDescription}, which has the following impact on your cancer risk **relative to population average:**`}</MarkdownTextTailwind>
        {props.affectedCancerTypes.map((cancerType) => {
          const impact = props.impactsByCancerType[cancerType];
          const isIncreased = impact > 0;

          return (
            <div className="modal-risk-item" key={cancerType}>
              <div className="w-[70px] text-left">
                <RiskBadge
                  value={formatRelativeRiskDecimal(Math.abs(impact), cancerType)}
                  variant={isIncreased ? 'error' : 'success'}
                  badgeType="change"
                  icon={isIncreased ? <UpArrow /> : <DownArrow />}
                  showPercent={false}
                />
              </div>
              <div className="modal-risk-text">
                {`Your ${normalizeCancerTypeName(cancerType)}${getCancerRiskSuffix(cancerType)} risk`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
